import { onError } from 'utils/helpers'
import { requestConfig } from '../../utils/httpClient'

function fetchGroups(data = {}) {
  return async dispatch => {
    dispatch({ type: 'CONTENT_LOADING', isLoading: true })

    function onSuccess(response) {
      const { status_id, detail } = response.data
      if (status_id !== 200) {
        throw response
      }

      dispatch({
        type: 'GROUPS_INFO',
        groups: detail,
      })
      return detail
    }

    try {
      const response = await requestConfig.get(
        `/api/v1/group?count=${data.count || 50}&page=${data.page || 1}&title=${
          data.title || ''
        }`
      )

      return onSuccess(response)
    } catch (error) {
      throw onError(error)
    } finally {
      dispatch({ type: 'CONTENT_LOADING', isLoading: false })
    }
  }
}

function fetchGroup(groupID) {
  return async dispatch => {
    dispatch({ type: 'CONTENT_LOADING', isLoading: true })

    function onSuccess(response) {
      const { status_id, detail } = response.data
      if (status_id !== 200) {
        throw response
      }

      return detail
    }

    try {
      const response = await requestConfig.get(
        `/api/v1/group?group_id=${groupID}`
      )

      return onSuccess(response)
    } catch (error) {
      throw onError(error)
    } finally {
      dispatch({ type: 'CONTENT_LOADING', isLoading: false })
    }
  }
}

/**
 * @param {Object} data
 */
function createGroup(data) {
  return async dispatch => {
    dispatch({ type: 'CONTENT_LOADING', isLoading: true })

    try {
      await requestConfig.post('/api/v1/group', data)
    } catch (error) {
      throw onError(error)
    } finally {
      dispatch({ type: 'CONTENT_LOADING', isLoading: false })
    }
  }
}

/**
 * @param {Object} data
 */
function removeGroup(data) {
  return async dispatch => {
    dispatch({ type: 'CONTENT_LOADING', isLoading: true })

    try {
      await requestConfig.delete(
        `/api/v1/group?employee_id=[${data.employee_id}]&access_object_id=[${data.access_object_id}]&group_id=${data.group_id}`
      )
    } catch (error) {
      throw onError(error)
    } finally {
      dispatch({ type: 'CONTENT_LOADING', isLoading: false })
    }
  }
}

export default {
  fetchGroups,
  fetchGroup,
  createGroup,
  removeGroup,
}
